<section>
    <div class="warning-icon">
        <mat-icon>warning</mat-icon>
    </div>
    <div class="warning-content">
        <span *ngIf="data.title" class="warning-title">{{data.title}}</span>
        <p *ngIf="data.message" class="warning-message" >{{data.message}}</p>
        <p *ngIf="data.message2" class="warning-message" >{{data.message2}}</p>
    </div>
    <div mat-dialog-actions class="button-content">
        <button mat-raised-button mat-dialog-close class="warning--button">OK</button>
    </div>
</section>
